<template>
  <base-modal
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Save"
    cancel-title="Cancel"
    cancel-variant="light"
    footer-class="justify-between"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div class="mb-4"><label for="title" class="block text-[13px] font-medium text-ink mb-1.5">Title</label>
        <input
          id="title"
          v-model="bodyClass.title"
          required
          placeholder=""
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
        >
      </div>

      <div class="mb-4"><label for="icon" class="block text-[13px] font-medium text-ink mb-1.5">Icon</label>
        <input
          id="icon"
          v-model="bodyClass.icon"
          required
          placeholder=""
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
        >
      </div>

      <div class="mb-4"><label for="status" class="block text-[13px] font-medium text-ink mb-1.5">Status</label>
        <base-select v-model="bodyClass.isActive" :options="statusOptions" value-key="value" label-key="text" placeholder="Select status"></base-select>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import { slugify } from '@/services/utils'
import BaseSelect from '../../UIComponents/BaseSelect'

export default {
  components: { BaseSelect },
  props: ['item', 'bodySlug'],
  data () {
    return {
      bodyClass: {
        title: '',
        slug: '',
        createdAt: '',
        icon: '',
        isActive: true,
        body: this.bodySlug
      }
    }
  },
  computed: {
    ...mapState({
      statusOptions: state => state.auth.statusOptions
    }),
    slug () {
      return slugify(this.bodyClass.title)
    },
    title () {
      if (this.item) {
        return 'Edit category'
      } else {
        return 'Add category'
      }
    }
  },
  methods: {
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      return valid
    },
    handleSubmit () {
      const { bodyClass, bodySlug } = this
      if (this.item) {
        this.$store.dispatch('UPDATE_BODY_CATEGORY', { bodySlug, bodyClass }).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      } else {
        this.bodyClass.slug = this.slug
        this.bodyClass.createdAt = dayjs().format()
        this.$store.dispatch('CREATE_BODY_CATEGORY', { bodySlug, bodyClass }).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      }
    },
    resetModal () {
      this.bodyClass.title = ''
      this.bodyClass.createdAt = ''
      this.bodyClass.slug = ''
      this.bodyClass.isActive = true
      this.bodyClass.icon = ''
      this.bodyClass.body = this.bodySlug
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        this.bodyClass.title = this.item.title
        this.bodyClass.createdAt = this.item.createdAt
        this.bodyClass.isActive = this.item.isActive
        this.bodyClass.slug = this.item.slug
        this.bodyClass.icon = this.item.icon
        this.bodyClass.body = this.item.body ? this.item.body : this.bodySlug
      }
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>